import { useState } from 'react'

const useDropdown = () => {
    const [isShowing, setIsShowing] = useState(false)

    function toggle() {
        setIsShowing(!isShowing)
    }

    return {
        isShowing,
        toggle,
    }
}

export default useDropdown
